<template>
  <div class="cookie-field">
    <div class="cookie-field__checkbox">
      <input
        type="checkbox"
        :id="id"
        :value="name"
        :checked="checked"
        :disabled="disabled"
        class="cookie-field__input"
        @change="$emit('change', $event.target.checked)">
      <div class="cookie-field__sprites">
        <sprite
          id="app/checkbox-empty"
          class="cookie-field__sprite cookie-field__sprite--empty" />
        <sprite
          id="app/checkbox-checked"
          class="cookie-field__sprite cookie-field__sprite--checked" />
      </div>
    </div>
    <label
      :for="id"
      class="cookie-field__label">
      <h3 class="cookie-field__headline">
        {{ $t(`${name}.label`) }}
      </h3>
      <div class="cookie-field__copy">
        {{ $t(`${name}.copy`) }}
      </div>
    </label>
  </div>
</template>

<script>
import Sprite from "@/shared/sprite";
import "/wds/sprites/app/checkbox-empty.svg";
import "/wds/sprites/app/checkbox-checked.svg";

export default {
  name: "CookieField",
  components: {
    Sprite
  },
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    name: { type: String, default: "" },
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    id() {
      return `cookie-${this.name}`;
    }
  },
  i18n: {
    messages: {
      en: {
        necessary: {
          label: "Functional",
          copy: "They help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies."
        },
        preferences: {
          label: "Preference",
          copy: "They enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in."
        },
        statistics: {
          label: "Statistical",
          copy: "They help website owners to understand how visitors interact with websites by collecting and reporting information anonymously."
        },
        marketing: {
          label: "Marketing",
          copy: "They are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user."
        }
      },
      de: {
        necessary: {
          label: "Notwendige",
          copy: "Diese Cookies sind für den Betrieb der Seite notwendig und ermöglichen unter anderem Basis-Funktionen wie Navigation sowie sicherheitsrelevante Funktionalitäten. Die Seite kann ohne diese Cookies nicht fehlerfrei funktionieren."
        },
        preferences: {
          label: "Präferenzen",
          copy: "Diese Cookies ermöglichen es uns, deine präferierten Einstellungen zum Aussehen oder Verhalten unserer Website, oder auch Sprache bzw. Region zu speichern, damit sie perfekt auf dich zugeschnitten ist."
        },
        statistics: {
          label: "Statistik",
          copy: "Um unser Angebot und unsere Webseite zu verbessern, erfassen wir anonymisierte Daten für Statistiken und Erhebungen. Mithilfe dieser Cookies können wir zum Beispiel den Effekt von bestimmten Inhalten auf unserer Webseite ermitteln und optimieren."
        },
        marketing: {
          label: "Marketing",
          copy: "Diese Cookies werden genutzt, um personalisierte Inhalte, passend zu deinen Interessen anzuzeigen. Sie ermöglichen es uns, dir besonders relevante Angebote zu präsentieren."
        }
      }
    }
  }
};
</script>

<style lang="scss">
.cookie-field {
  $root: &;

  @include font-family(sans-serif);

  display: flex;
  align-content: flex-start;

  &__checkbox {
    position: relative;

    margin-right: $spacing-8;
  }

  /* stylelint-disable-next-line selector-nested-pattern */
  input {
    position: absolute;
    z-index: 1;

    width: 100%;
    padding-top: 100%;

    opacity: 0;

    &:checked + #{$root}__sprites {

      #{$root}__sprite {

        &--empty {
          display: none;
        }

        &--checked {
          display: block;
        }
      }
    }

    &:disabled + #{$root}__sprites {
      color: $light-grey;
    }
  }

  &__sprite {

    &--checked {
      display: none;
    }
  }

  &__headline {
    @include font-style(subheadline);

    margin-bottom: $spacing-8;
  }

  &__copy {
    @include font-style(legal, $color: $dark-grey);
  }
}
</style>
